import { PaletteOptions } from '@mui/material/styles';


export const defaultPalette: PaletteOptions = {
    text: {
        primary: 'rgba(0, 0, 0, 0.87)',
        secondary: 'rgba(0, 0, 0, 0.54)',
        disabled: 'rgba(0, 0, 0, 0.38)',
      },
      action: {
        active: 'rgba(0, 0, 0, 0.54)',
        selected: 'rgba(0, 0, 0, 0.08)',
        disabled: 'rgba(0, 0, 0, 0.26)',
        hover: 'rgba(0, 0, 0, 0.04)',
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
      },
      background: {
        default: '#f4f5f6',
        paper: '#FFF',
      },
      divider: 'rgba(0, 0, 0, 0.12)',
      primary: {
        main: '#50248D',
        dark: '#1d005f',
        fade: '#f9f5ff',
        light: '#8150be',
        shade: '#2e194b',
      },
      secondary: {
        main: '#e9015b',
        dark: '#b00032',
        fade: '#ffebf2',
        light: '#ff5788',
        shade: '#82002a',
      },
      error: {
        main: '#ff3729',
        dark: '#c30000',
        fade: '#fff1f0',
        light: '#ff7155',
        shade: '#8a0000',
      },
      warning: {
        main: '#f97e06',
        dark: '#bf4f00',
        fade: '#fff4eb',
        light: '#ffaf45',
        shade: '#643202',
      },
      info: {
        main: '#3aa3d2',
        light: '#76d4ff',
        dark: '#0074A1',
        fade: '#EBF8FF',
        shade: '#164D62',
      },
      success: {
        main: '#2ece9a',
        dark: '#009c6c',
        light: '#6fffcb',
        fade: '#ECFDF8',
        shade: '#005237',
      },
    } 